"use client";

import { useEffect } from "react";
import { Shortcut, sharedManager } from "./keyboard-shortcuts-manager-v2";

export function useKeyboardShortcuts(
	shortcuts: Shortcut[],
	layerName: string,
	deps?: unknown[],
) {
	useEffect(() => {
		return sharedManager.registerShortcuts(shortcuts, layerName);
	}, deps);
}
